import { render, staticRenderFns } from "./ReturnsBoardDetailsView.vue?vue&type=template&id=6a11d946&scoped=true&"
import script from "./ReturnsBoardDetailsView.vue?vue&type=script&lang=js&"
export * from "./ReturnsBoardDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./ReturnsBoardDetailsView.vue?vue&type=style&index=0&id=6a11d946&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a11d946",
  null
  
)

export default component.exports